module.exports = __webpack_public_path__ + "static/media/movilgositoMano.4b19b150.png";